export default __webpack_public_path__ + "static/showcase-b20111aecd97b05438cad21558f45983.png";